import { Header } from "./components/Header/index";
import { Body } from "./components/Body/index";
import { Footer } from "./components/Footer/index";
import "./App.css";

function App() {
  return (
    <>
      <Header />
      <Body />
      <Footer />
    </>
  );
}

export default App;
